
module.factory('LogInfo', function($http, ApiUrl, $timeout) {

    function Log(program, type, params) {
        this._params = params || {};
        this._url = ApiUrl('program', program.id, 'log', type);
    }

    Log.prototype.load = function() {
        var self = this;
        return $http.get(self._url, {params: self._params})
            .then(function(result) {
                angular.extend(self, result.data);
                return self;
            });
    }

    Log.prototype.refresh = function() {
        var self = this;
        $timeout.cancel(self._timeoutPromise);
        this._timeoutPromise = $timeout(function() {
            return self.load();
        }, 50);
        return this._timeoutPromise;
    }

    return Log;

});

module.component('logInfo', {
    controllerAs: '$ctrl',

    bindings: {
        log: "="
    },
    templateUrl: 'programs/info/logInfo',
    controller: function($scope) {
    }
});